/**
 * App Router created by karora on 11/03/17.
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignUp } from './forms/signup.component';
import { Update } from './forms/update.component';
import { Success } from './messages/success.component'
import { Fail } from './messages/fail.component'; 

const routes: Routes = [
  { path: 'signup/:hash', component: SignUp },
  { path: 'update/:hash', component: Update },
  { path: 'success', component: Success },
  { path: 'fail', component: Fail },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
